import { FirestoreDataConverter, Timestamp } from 'firebase/firestore';
import { plainToInstance, instanceToPlain } from 'class-transformer';

export type Type<T, Props extends any[] = any[]> = {
  new (...args: Props): T;
};

function isTimestamp(value: unknown): boolean {
  return (
    !!value && Boolean((value as Record<string, unknown>).seconds && (value as Record<string, unknown>).nanoseconds)
  );
}

function buildNonPrimitivesValues(object: Record<string, unknown>): Record<string, unknown> {
  const result = { ...object };
  const keys = Object.keys(object);

  keys.forEach((key) => {
    /** Building timestamp */
    if (typeof object[key] === 'object' && isTimestamp(object[key])) {
      const valueAsObj = object[key] as Record<string, unknown>;

      result[key] = new Timestamp(valueAsObj.seconds as number, valueAsObj.nanoseconds as number);
      return;
    }

    /** Formating array */
    if (Array.isArray(object[key])) {
      return;
    }

    if (object[key] && typeof object[key] === 'object') {
      const res = buildNonPrimitivesValues(object[key] as Record<string, unknown>);
      result[key] = res;
    }
  });

  return result;
}

export function converterOf<T extends object>(type: Type<T, T[]>): FirestoreDataConverter<T> {
  return {
    fromFirestore: (snapshot) => plainToInstance(type, snapshot.data(), { enableCircularCheck: true }),
    toFirestore: (input: any) => {
      const isResource = input instanceof type;

      const resource = isResource
        ? input
        : plainToInstance(type, input, { enableCircularCheck: true, exposeUnsetFields: false });

      return buildNonPrimitivesValues(
        instanceToPlain(resource, { exposeUnsetFields: false, enableCircularCheck: true })
      );
    },
  };
}
